module.exports = __webpack_public_path__ + "img/success_txt@2x.8b719e09.png";